export default function Viewmodel$reset ( data ) {
	this.data = data;
	this.clearCache( '' );
}